import React from 'react';
import { Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { genfunction } from 'helpers'
const { CartDiscardMsg, CartDiscardTime } = window['runConfig'];



const CartDiscardTimeInfo = props => {

    const carddiscard = useSelector(state => state.reducerCardDiscardTime);
    const events = useSelector(state => state.reducerShopCart.events);
    const MembershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
    const GATickets = useSelector(state => state.reducerShopCart.GATickets);
    const giftcards = useSelector(state => state.reducerGiftCards);
    const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);
    const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);

    const ShowGiftCards = () => {
        let res = false;
        if (giftcards.giftcards && giftcards.giftcards.length > 0) {
            if (giftcards.giftcards.filter(x => x.AddedToCart === true).length > 0) {
                res = true;
            }
        }

        return res;
    }

    function millisecondsToTime(milli) {
        var seconds = Math.floor((milli / 1000) % 60);
        var minutes = Math.floor((milli / (60 * 1000)) % 60);
        return minutes + ":" + genfunction.PaddingString(seconds, "0", 2);
    }

    return (
        (events.length > 0 || MembershipPackages.length > 0 || GATickets.length > 0 || orderProducts.length > 0 || ShowGiftCards() || donationProducts.length > 0) && CartDiscardTime > 0 ?

            <Typography variant="h5" component="h5" style={{ marginTop: props.MarginTop }}>
                {CartDiscardMsg} {" "} {millisecondsToTime(carddiscard.DiscardTime * 1000)}
            </Typography> : ""

    );
};

export default CartDiscardTimeInfo;
